module.exports = __webpack_public_path__ + "media/online_learning/comparison-3504f399.svg";